import React from 'react';
import createSvgIcon from '../../../utils/createSvgIcon';

export default createSvgIcon(
  [<g fill="currentColor" key="0"><path d="M12 15.2c1.7674 0 3.2-1.4326 3.2-3.2S13.7674 8.8 12 8.8 8.8 10.2328 8.8 12s1.4327 3.2 3.2 3.2" /><path d="M9 2 7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5" /></g>,<defs key="1"></defs>,]
, 'CameraPhotoCameraPhotoCameraFilledx');
